import { Paper } from "@mui/material";
import React, { useState, useEffect } from "react";
import CommentBox from "./CommentBox";
import ToggleThumb from "../common/ToggleThumb";
import ThumbDownIcon from '@mui/icons-material/ThumbDown';

// import { Rating } from 'react-simple-star-rating';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
// import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { formatDisc, SliceEnum } from "../common/codeHelper";
import ReportView from "../DCM/Viewer/ReportView";
import { EventEmitter } from "../../event";
import { getCurrentAnalysis } from "../../service/api.service";

function Report(props) {
  const [reportImageData, setReportImageData] = useState();
  const [analysis, setAnalysis] = useState();

  let patientAnalysis = '';

  useEffect(() => {
    if (props.patientAnalysis && !patientAnalysis) {
      getData();
      EventEmitter.subscribe("feebackToggle", (event) => {
        const analys = getCurrentAnalysis();
        setAnalysis(analys.spinaAnalysis);
      })
    }
    // if (analysis?.exclusionText) {
    //   document.body.style.overflow = "hidden";
    // }
    // return () => {
    //   document.body.style.overflowX = "hidden";
    //   document.body.style.overflowY = "auto";
    // }
  });




  const getData = () => {
    patientAnalysis = props.patientAnalysis;
     setAnalysis(patientAnalysis.spinaAnalysis);
    patientAnalysis.spinaAnalysis.analysisOutputs.forEach(element => {
      if (element.outputType === SliceEnum.SAGITTAL_SEGMENTATION_RESULT_MEDICAL_MODEL) {
        setReportImageData(element.sliceInfos);
      }
    });


  }




  return (
    <div className="realtive p-2 pt-10 mt-8">
     
      <div className="flex flex-row mb-8 mt-6">
        <div className="w-full lg:w-40 text-lg font-semibold flex items-center justify-center animate__animated animate__fadeInLeft "> Prediction: </div>
        <div className="flex w-2/3 t-detail animate__animated animate__fadeInDown">
          <TableContainer component={Paper}>
            <Table aria-label="customized table">
               
              <TableBody>
                <TableRow>
                  {analysis?.diskWisePredictions &&
                    analysis.diskWisePredictions.map((pred, index) => {
                      return pred.targetted ?
                        <TableCell className="mt-2 bg-gray-100" key={index} >
                           <div className="w-40 display-inline  text-right relative" >
                              <span className="font-semibold mr-2">{formatDisc(pred.diskCode)}: </span>   <span className="display-inline">Target</span> 
                              <span className="w-14 inline text-right absolute" ><ToggleThumb diskCode={pred.diskCode} msg={pred.negativeFeedback} /></span>
                           </div>
                         
                        </TableCell>
                        :
                        <TableCell key={index} className="bg-gray-100" >
                          <div className="w-40 display-inline  text-right relative" >
                            <span className="font-semibold mr-2">{formatDisc(pred.diskCode)}: </span>  <span className="display-inline">Non-target</span>
                            <span className="w-14 inline text-right absolute" ><ToggleThumb diskCode={pred.diskCode} msg={pred.negativeFeedback}/> </span>  
                          </div>
                        </TableCell>
                    })
                  }
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </div>
      <div className="mt-4 mb-4 transition delay-300 duration-300 ease-in-out ">
        <ReportView sliceData={{ reportImageData }} analysis={{ analysis }} sx={{ marginTop: '2rem ' }} />
      </div>
      <Paper elevation={3} className="p-4 animate__animated animate__fadeInUp ">
        <div className="m-1">
          <div className="font-semibold text-[#1b2a47] font-xl mb-2 pb-3">
            <svg className="inline-block h-6 w-6 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
              <path strokeLinecap="round" strokeLinejoin="round" d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z" />
            </svg>
            Surgeon Notes
          </div>
          <div className="mb-3 w-full">
            {analysis?.diskWisePredictions &&
              analysis.diskWisePredictions.map((pred, index) => {
                return pred.negativeFeedback ?
                  <div className="block  my-3 w-full pb-3" key={index} >
                    <span className="p-2	bg-blue-200 text-blue-900  comment-arrow mr-6 mb-6  "> <b>{formatDisc(pred.diskCode)}</b></span>

                    {pred.negativeFeedback} <ThumbDownIcon sx={{ fontSize: '15px', color: '#f05858' }} />
                  </div>
                  :
                  ''
              })
            }
          </div>
        </div>
        <div className="mt-4">
           <CommentBox />
        </div>

      </Paper>

    </div>
  )
}

export default Report;
